import { Component, Inject, OnInit } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";

@Component({
	selector: "app-sample-dialog",
	templateUrl: "./sample-dialog.component.html",
	styleUrls: ["./sample-dialog.component.scss"],
})
export class SampleDialogComponent {
	for: string;

	constructor(@Inject(MAT_DIALOG_DATA) data: any) {
		this.for = data;
	}
}
